import React from 'react';
import * as S from './PaintColourMobileControls.style';
import { useStyles } from '@archipro-design/aria';
import { ReseneViewProduct, ShoppingCart, Trash } from '@archipro-design/icons';
import { usePaintPickerContext } from '@modules/paint-picker-new/context/PaintPickerContext';
import type { PaintProduct } from '@modules/paint-picker-new/type';

interface PaintColourMobileControlsProps {
    paint: PaintProduct;
}

export const PaintColourMobileControls = ({
    paint,
}: PaintColourMobileControlsProps) => {
    const { addPaintToCart, removePaint, goToProductPage } =
        usePaintPickerContext();
    const { css } = useStyles();

    return (
        <div className={css(S.Container)}>
            {paint.variantId ? (
                <div
                    className={css(S.Button)}
                    onTouchStart={() => addPaintToCart(paint)}
                >
                    <ShoppingCart className={css(S.ButtonIcon)} />
                </div>
            ) : paint.link ? (
                <div
                    className={css(S.Button)}
                    onTouchStart={() => goToProductPage(paint)}
                >
                    <ReseneViewProduct className={css(S.ButtonIcon)} />
                </div>
            ) : null}

            <div
                className={css(S.Button)}
                onTouchStart={() => removePaint(paint.id)}
            >
                <Trash className={css(S.ButtonIcon)} />
            </div>
        </div>
    );
};
